import React, { useEffect, useRef } from "react";
import "./styles.scss";
import "./mobile.scss";
import "../../../../utils/auth";
import { getInsight } from "../../../../utils";

const Index = () => {
  const adUrl = process.env.REACT_APP_HOME_TOP_LEFT_ADV;
  const iframeRef = useRef(null);

  // useEffect(() => {
  //     // Send insight_id to iframe after it loads
  //     const sendInsight = async () => {
  //         try {
  //             const insight = await getInsight();
  //             console.log({insight});
  //             const insight_id = insight.insight_id;
  //
  //             iframeRef.current?.contentWindow.postMessage(
  //                 { insight_id },
  //                 process.env.REACT_APP_HOME_TOP_LEFT_ADV // target origin for security
  //             );
  //         } catch (err) {
  //             console.warn("Failed to get insight", err);
  //         }
  //     };
  //
  //     const iframe = iframeRef.current;
  //     if (iframe) {
  //         iframe.addEventListener("load", sendInsight);
  //     }
  //
  //     return () => {
  //         if (iframe) {
  //             iframe.removeEventListener("load", sendInsight);
  //         }
  //     };
  // }, [insight]);

  useEffect(() => {
    let isMounted = true; // To prevent setting state or calling refs if unmounted
    let insight_id = null;

    const setup = async () => {
      try {
        const insight = await getInsight();

        if (isMounted && insight && insight.insight_id) {
          insight_id = insight.insight_id;

          const iframe = iframeRef.current;
          const sendInsight = () => {
            if (iframe?.contentWindow) {
              iframe.contentWindow.postMessage(
                { insight_id },
                process.env.REACT_APP_HOME_TOP_LEFT_ADV
              );
            }
          };

          // Add listener only after insight is confirmed
          iframe?.addEventListener("load", sendInsight);

          // Cleanup
          return () => {
            iframe?.removeEventListener("load", sendInsight);
          };
        }
      } catch (err) {
        console.warn("Failed to get insight", err);
      }
    };

    setup();

    return () => {
      isMounted = false;
    };
  }, [adUrl]); // Empty dependency array

  if (!adUrl) {
    return <div className="top-ad">Ad URL not configured.</div>;
  }
  return (
    <div className="top-ad active">
      <iframe
        ref={iframeRef}
        title="Advertisement"
        src={adUrl}
        style={{
          width: "545px",
          height: "100%",
          border: "none",
          display: "block",
        }}
        loading="lazy"
        sandbox="allow-scripts allow-same-origin allow-popups" // Optional
      />
    </div>
  );
};

export default Index;
